import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./assets/styles/combination.styles";
import ColorPicker from "./ColorPicker";
import FormatPicker from "./FormatPicker";
import Button from "@material-ui/core/Button";
import replayIcon from "./assets/images/replay.svg";
import combinationOfPhotos from "./assets/meta/Combinations";
import { useMediaQuery } from "@material-ui/core";
import colorsLength from "./assets/meta/Colors";
import clsx from "clsx";
import BlockRevealImage from "../BlockRevealImage";
import useElementVisible from "../app/hooks/useElementVisible";
import OnViewPortObserver from "../OnViewPortObserver";

const useStyles = makeStyles(styles);

export default function CombinationPicker() {
  const [combinations, setCombinations] = useState({
    color: 1,
    format: 1,
  });
  const [imageVisible, setImageVisible] = useElementVisible({ image: false });
  const [visibleCombinations, setVisibleCombinations] = useState({
    color: 1,
    format: 1,
  });
  const [isFading, setFading] = useState(false);
  const setFadingTimeout = (fn) => {
    setFading(true);
    setTimeout(() => {
      fn();
      setFading(false);
    }, 300);
  };
  const setColor = (color) => {
    setVisibleCombinations({ ...visibleCombinations, color });
    setFadingTimeout(() => setCombinations({ ...combinations, color }));
  };
  const setFormat = (format) => {
    setVisibleCombinations({ ...visibleCombinations, format });
    setFadingTimeout(() => setCombinations({ ...combinations, format }));
  };
  const guaranteeRandomNum = (oldNum, max) => {
    let newNum = Math.floor(Math.random() * max);
    while (true) {
      if (newNum !== oldNum) break;
      else newNum = Math.floor(Math.random() * max);
    }
    return newNum;
  };
  const setRandomComb = () => {
    const newColor = guaranteeRandomNum(
      combinations.color,
      colorsLength.length
    );
    const newFormat = guaranteeRandomNum(combinations.format, 2);
    setVisibleCombinations({ color: newColor, format: newFormat });
    setFadingTimeout(() =>
      setCombinations({ color: newColor, format: newFormat })
    );
  };
  const isMobile = useMediaQuery("(max-width: 1080px)");
  const src =
    combinationOfPhotos[combinations.color + 1][combinations.format + 1];
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <span className={classes.span}>
        <h1 className={classes.h1}>
          Esplora tutti gli stili, guarda come cambia l’atmosfera
        </h1>
        <ColorPicker
          index={visibleCombinations.color}
          handleChange={setColor}
        />
        <FormatPicker
          setFormat={setFormat}
          state={visibleCombinations.format}
        />
        {!isMobile && (
          <Button
            onClick={setRandomComb}
            className={classes.btn}
            style={{ cursor: "none" }}
            variant="outlined"
            endIcon={
              <img
                src={replayIcon}
                style={{ transform: "scale(1.2)" }}
                alt="replay icon"
              />
            }
          >
            Crea una configurazione casuale
          </Button>
        )}
      </span>
      <BlockRevealImage
        imageSrc={src}
        isInView={imageVisible.image}
        blockRevealClass={classes.blockRevealWrapper}
        imgAlt="pickedColor"
        imageClass={clsx(classes.imgPicker, isFading && classes.fadeImg)}
      />
      <OnViewPortObserver
        onEnterViewPort={() => setImageVisible("image")}
        y="300px"
        yMobile="500px"
        absolute
      />
      {isMobile && (
        <Button
          className={classes.btn}
          onClick={setRandomComb}
          variant="outlined"
          endIcon={
            <img
              src={replayIcon}
              style={{ transform: "scale(1.2)" }}
              alt="replay icon"
            />
          }
        >
          Genera configurazione casuale
        </Button>
      )}
    </div>
  );
}
